var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-display-flex u-width--100% u-justify-content-center u-align-items-center u-flex-direction-column",class:{ 'u-margin-top u-margin-bottom': !_vm.noMargin }},[_c('span',{staticClass:"loader primary-loading small-loader"}),(_vm.message)?_c('small',{staticClass:"u-margin-top"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }